import { Outlet } from "react-router-dom";

export default function AuthLayout() {
  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <a href="/" className="brand">
          <div className="brand-badge">WA</div>
          <div className="brand-txt">
            <div className="title">WhatsPlatinum</div>
            <div className="sub">Panel profesional</div>
          </div>
        </a>
        <Outlet />
      </div>
    </div>
  );
}
